/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
const e = "Formeck", o = "NubeteckConfig", t = 24, _ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MAX_COLUMNS_ANTD: 24,
  NUBETECK_CONFIG_KEY_NAME: o,
  PACKAGE_NAME: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  t as M,
  o as N,
  e as P,
  _ as c
};
